// missionConstants.js
'use strict';

export const MissionSectionType = {
  ANCHOR: 'anchor',
  SECTION: 'section',
};

export const MISSION_TOOLTIP_SEEN_KEY = 'mission_campaign_tooltip_seen';
